<div class="content">
  <span class="header">Appointments &amp; Reminders</span>

  <div class="flex-1 appointments">
    <ng-container *ngFor="let appointment of appointments">
      <hh-appointment-list-item
        [type]="appointment.type"
        [time]="appointment.time"
        [label]="appointment.label"
        [description]="appointment.description"
      />
    </ng-container>
  </div>
</div>
